// @flow
import React from "react";
import TokenContainer from "./TokenContainer";
import ModalContainer from "./ModalContainer";
import SnackbarContainer from "./SnackbarContainer";

// 다양한 container 들을 포함하도록 감싸줌.
export default class ContainerProvider extends React.PureComponent {
  render() {
    return (
      <>
        <TokenContainer />
        <ModalContainer />
        <SnackbarContainer />
        {this.props.children}
      </>
    );
  }
}
